import { useMatch } from 'react-router';
import { StreamState } from '@/__generated__/graphql.ts';
import { paths } from '@/routes-utils/paths.ts';
import { makeSelectOptions } from '@/routes/_app.p.marketplace.streams/stream-filters/make-select-options.ts';
import { StreamFilterItem } from '@/routes/_app.p.marketplace.streams/stream-filters/stream-filters.tsx';

const AllStreamsStateOptions = {
  All: 'All states',
  [StreamState.Active]: 'Active',
  [StreamState.Inactive]: 'Inactive',
  [StreamState.OnHold]: 'On hold',
};

const CreatedStreamsStateOptions = {
  ...AllStreamsStateOptions,
  [StreamState.Draft]: 'Draft',
};

const allStreamsStateSelectOptions = makeSelectOptions(AllStreamsStateOptions);
const createdStreamsStateSelectOptions = makeSelectOptions(
  CreatedStreamsStateOptions,
);

export const StreamStateFilter = () => {
  const createdStreams = useMatch(paths.streamsCreated);
  const customCreatedStreams = useMatch(paths.customStreamsCreated);
  const isCreated = createdStreams || customCreatedStreams;

  return (
    <StreamFilterItem
      paramName={'streamState'}
      defaultValue={'All'}
      optionsEntity={
        isCreated ? CreatedStreamsStateOptions : AllStreamsStateOptions
      }
      options={
        isCreated
          ? createdStreamsStateSelectOptions
          : allStreamsStateSelectOptions
      }
    />
  );
};
